import { useState } from 'react';
import type { FormEvent } from 'react';
import { bootstrapAdmin } from '../lib/api';

export default function SetupScreen() {
  const [token, setToken] = useState('');
  const [id, setId] = useState('admin-001');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setMessage('');
    if (password !== confirmPassword) {
      setMessage('Passwords do not match.');
      setBusy(false);
      return;
    }
    try {
      await bootstrapAdmin(token, id, name, email, password);
      setMessage('Admin created. You can now return to the login page.');
      setToken('');
    } catch (error) {
      setMessage(error instanceof Error ? error.message : 'Bootstrap failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="loading-shell">
      <section className="auth-card">
        <p className="eyebrow">TALKUP · FIRST SETUP</p>
        <h1>Create admin</h1>
        <p>One-time setup. The bootstrap token is sent only over HTTPS and is not stored by the page.</p>
        <form onSubmit={submit}>
          <label>Bootstrap token<input type="password" value={token} onChange={(e) => setToken(e.target.value)} required autoComplete="off" /></label>
          <label>Admin ID<input value={id} onChange={(e) => setId(e.target.value)} required /></label>
          <label>Name<input value={name} onChange={(e) => setName(e.target.value)} required autoComplete="name" /></label>
          <label>Email<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" /></label>
          <label>Password<input type="password" minLength={10} value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="new-password" /></label>
          <label>Confirm password<input type="password" minLength={10} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required autoComplete="new-password" /></label>
          <button type="submit" disabled={busy}>{busy ? 'Creating…' : 'Create admin'}</button>
        </form>
        {message && <p className={message.startsWith('Admin created') ? 'form-success' : 'form-error'}>{message}</p>}
        {message.startsWith('Admin created') && <p><a href="/">Open TalkUp login</a></p>}
      </section>
    </main>
  );
}
